import React from 'react';
import ReactApexChart from 'react-apexcharts';

const HourlyMessageAnalytics = ({dataMap}) => {
  // Example data: message volume for each hour (0 to 23)
  const barChartSeries = [
    {
      name: 'Messages',
      data: dataMap?.data ?? [
        10, 15, 12, 20, 35, 40, 55, 60, 75, 80, 90, 85,
      ],
    },
  ];

  const barChartOptions = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: false,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: dataMap?.labels ?? [
        '1', '2', '3', '4', '5', '6', '7',
        '8', '9', '10', '11', '12',
      ],
      labels: {
        rotate: -45,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Messages',
      },
      min: 0,
      max: 120,
    },
    fill: {
      opacity: 1,
      colors: ['#2563EB'],
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} messages`,
      },
    },
  };

  return (
    <div className="col-md-4">
      <div className="card h-100 radius-8 border">
        <div className="card-body p-24">
          <div className="d-flex align-items-center gap-2 mb-20">
            <div>
              <h6 className="mb-2 text-lg">Hourly Activity</h6>
              <p>Message volume by hour of day</p>
            </div>
          </div>
          <ReactApexChart options={barChartOptions} series={barChartSeries} type="bar" height={264} />
        </div>
      </div>
    </div>
  );
};

export default HourlyMessageAnalytics;
